import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/shared/stores/authStore';
import { ROUTES } from '@/shared/config/constants';
import { Skeleton } from '@/shared/ui';

const OnboardingSkeleton = () => (
  <div
    className="flex min-h-dvh flex-col bg-background px-6 py-8"
    aria-busy="true"
    aria-label="Carregando onboarding"
  >
    <div className="mx-auto flex w-full max-w-md flex-col gap-6">
      <Skeleton className="h-1.5 w-full rounded-full" />
      <div className="flex flex-col items-center gap-3 text-center">
        <Skeleton className="size-10 rounded-xl" />
        <Skeleton className="h-6 w-64" />
        <Skeleton className="h-3 w-72" />
      </div>
      <Skeleton className="mt-4 h-12 w-full rounded-lg" />
      <Skeleton className="mt-2 h-11 w-full rounded-lg" />
    </div>
  </div>
);

export const OnboardingGuard = () => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isHydrating = useAuthStore((s) => s.isHydrating);
  const user = useAuthStore((s) => s.user);

  if (isHydrating) return <OnboardingSkeleton />;

  if (!isAuthenticated || !user) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  if (user.onboardingCompleto) {
    return <Navigate to={ROUTES.APP.MATCHES} replace />;
  }

  return <Outlet />;
};
